
import React from 'react';
import { Button } from '@/components/ui/button';
import { Youtube } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

const YouTubeSubscribeBanner: React.FC = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  
  const bannerBg = isDark ? 'bg-[#222222]' : 'bg-white'; // Changed from bg-[#f1f1f1] to bg-white
  const textColor = isDark ? 'text-white' : 'text-black';
  const borderColor = isDark ? 'border-[#333333]' : 'border-[#dddddd]';
  
  return (
    <div className={cn(
      "my-10 p-4 border rounded-md flex items-center justify-between flex-wrap gap-4",
      borderColor
    )}>
      <div className="flex items-center gap-3">
        <div className="hidden sm:flex h-10 w-10 bg-red-600 items-center justify-center rounded-full">
          <Youtube size={20} className="text-white" />
        </div>
        <div>
          <h3 className={cn("text-sm font-medium", textColor)}>
            Subscribe to Everhouse YouTube
          </h3>
          <p className={cn("text-xs", isDark ? "text-gray-400" : "text-gray-600")}>
            Get the latest videos, stories, and exclusive content
          </p>
        </div>
      </div>
      
      <a 
        href="https://youtube.com/everhouseco" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <Button 
          size="sm"
          className="bg-red-600 hover:bg-red-700 text-white font-medium w-full"
        >
          <Youtube size={16} className="mr-2" />
          Subscribe
        </Button>
      </a>
    </div>
  );
};

export default YouTubeSubscribeBanner;
